"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyEffect_OnAttackedEventHandlerScript = void 0;
const Registries_1 = require("../../core/state/Registries");
const Random_1 = require("../../utils/Random");
let ApplyEffect_OnAttackedEventHandlerScript = class ApplyEffect_OnAttackedEventHandlerScript {
    run(sequence, container, handler, event) {
        const { applyTo, onHitOnly = true, effects } = handler.args.scriptArgs;
        if (onHitOnly && !event.args.hit) {
            return;
        }
        const targetId = applyTo === "attacker" ? event.args.attackerId
            : event.subject;
        effects
            .filter(args => !args.percentChance || (0, Random_1.random)(1, 100) <= args.percentChance)
            .forEach(({ effect, duration, supernatural = false }) => {
            if (effect.harmful) {
                container.applyDebuff({
                    sequence,
                    attackerId: event.subject,
                    targetId,
                    duration,
                    effect,
                    supernatural
                });
            }
            else {
                container.applyBuff({
                    sequence,
                    creatorId: event.subject,
                    targetId,
                    duration,
                    effect,
                    supernatural
                });
            }
        });
    }
};
ApplyEffect_OnAttackedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("ApplyEffect_OnAttacked")
], ApplyEffect_OnAttackedEventHandlerScript);
exports.ApplyEffect_OnAttackedEventHandlerScript = ApplyEffect_OnAttackedEventHandlerScript;
